import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { NumberInput } from '../Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

function Fuel ({ device }) {
  const [state, setState] = useState({
    fuelTankSize: device.physical.fuelTankSize,
    fuelSensorRange: device.physical.fuelSensorRange,
  })

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        fuelTankSize: state.fuelTankSize,
        fuelSensorRange: state.fuelSensorRange,
      },
    })
  }, [state.fuelTankSize, state.fuelSensorRange])

  const handleChange = useCallback(
    (field, value, callback) => {
      const newState = update(state, {
        [field]: { $set: value },
      })

      setState(newState)

      // Use setTimeout to ensure state is updated before dispatching
      setTimeout(() => {
        appDispatch()
        if (callback) callback()
      }, 0)
    },
    [state, appDispatch]
  )

  const childChange = useCallback(
    (event) => {
      handleChange(event.target.name, event.target.value)
    },
    [handleChange]
  )

  useEffect(() => {
    appDispatch()
  }, [appDispatch])

  const unit = 'ft'
  const steps = 0.1

  const labelFuelTank = 'Fuel Tank Size'
  const labelFuelSensor = 'Fuel Sensor Range'

  return (
    <div>
      <section>
        <h3>Current Setting</h3>
        <ul>
          <li>
            <span>{labelFuelTank}</span>
            <span>
              {device.physical.fuelTankSize}
              {unit}
            </span>
          </li>
          <li>
            <span>{labelFuelSensor}</span>
            <span>
              {device.physical.fuelSensorRange}
              {unit}
            </span>
          </li>
        </ul>
      </section>
      <section>
        <h3>New Setting</h3>
        <ul>
          <li>
            <span>{labelFuelTank}</span>
            <span>
              <NumberInput
                value={state.fuelTankSize}
                childChange={childChange}
                field='fuelTankSize'
                steps={steps}
              />
              {unit}
            </span>
          </li>
          <li>
            <span>{labelFuelSensor}</span>
            <span>
              <NumberInput
                value={state.fuelSensorRange}
                childChange={childChange}
                field='fuelSensorRange'
                steps={steps}
              />
              {unit}
            </span>
          </li>
        </ul>
      </section>
    </div>
  )
}

Fuel.propTypes = {
  device: PropTypes.object.isRequired,
}

export default Fuel
